import {mergeToHierarchy} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import EventDisclaimerView from './event-disclaimer-view.jsx';
import {eventDisclaimerFactory} from './event-disclaimer.factory';

import PALETTE_SCHEMA from './event-disclaimer.palette-schema.yaml';
import SCHEMA from './event-disclaimer.schema.yaml';

class EventDisclaimerFeature extends AbstractVisualFeature {
    get name() {
        return 'EventDisclaimer';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return eventDisclaimerFactory(PALETTE);
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        mergeToHierarchy(mojitoConfig, 'services.viewImplementations', {
            EventDisclaimer: {
                implementation: EventDisclaimerView,
            },
        });

        mergeToHierarchy(mojitoConfig, 'services.configurations', {
            EventDisclaimer: {
                displayForSports: this.config.displaySportsList,
                infoLink: {
                    link: this.config.infoLinkUrl,
                },
            },
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

// Exporting it, as it is used in playground
export const EventDisclaimer = new EventDisclaimerFeature(SportsContent);
